<template>
  <el-container class="tobigpicmain">
    <!-- <el-header height="70px">
      <homeHeader :opacity="opacity"></homeHeader>

    </el-header>-->
    <el-main class="main">
      <div class="container">
        <search-horizontal style="max-width: 1280px;margin: 20px auto 0;"></search-horizontal>
        <div class="mainTop">
          <div class="BigLeft">
            <img v-if="solaBig.asset_type == 1" class="Biglayer-img" :src="solaBig.extension_info.oss_800_watermark" alt="">
            <img v-if="solaBig.asset_type == 3" class="Biglayer-img" :src="solaBig.extension_info.video_image" alt="">
            <div class="Biglayer"></div>
            <div class="BigButton">
              <a v-if="group.group_total > 1" :href="'/search?isEnglish=false&type=1&text=&group_id='+group.group_id" :style="{'width': (isGaonS&&isEnglish ? '120px':'')}">
                <img src="../../static/images/icon/CombinedShape.svg" alt="">

                {{isGaonS?isEnglish?"Back Photos":"返回组照":"返回组照"}}
              </a>
              <a @click="collectImg(solaBig.asset_id)" :style="{'width': (isGaonS&&isEnglish ? '120px':'')}">
                <img src="../../static/images/icon/collect.svg" alt="">

                {{isGaonS?isEnglish?"Add Favorites":"加入收藏":"加入收藏"}}
              </a>
            </div>
            <div class="BigSwiper">
              <div class="bigChange">
                <!-- <img
                  oncontextmenu="return false"
                  :src="solaBigextension_infooss_800"
                  alt=""
                >-->
                <img
                  :src="solaBig.extension_info.oss_800_watermark"
                  alt
                  v-if="solaBig.asset_type == 1"
                />
                <video
                  id="my-video"
                  controlslist="nodownload"
                  controls
                  autoplay="autoplay"
                  preload="auto"
                  width="100%"
                  height="auto"
                  style="vertical-align:middle"
                  :poster="solaBig.extension_info.video_image"
                  :src="solaBig.extension_info.preview_ossid"
                  type="video/mp4"
                  v-if="solaBig.asset_type == 3"
                ></video>
              </div>
            </div>
            <div class="BigTab">
              <div
                v-if="(group.items)&&(group.items.length>1)"
                class="next"
                @click="preAndNext('gt')"
              >
                <div class="gt"></div>
              </div>
              <div v-if="(group.items.length>1)" class="prev" @click="preAndNext('lt')">
                <div class="lt"></div>
              </div>
            </div>
            <div class="Big-info-ll">
              <div v-if="columnsView.includes('download_times')">
                <span class="binfotitle">{{isGaonS?isEnglish?"Downloads：":"下载次数：":"下载次数："}}</span>
                {{ solaBig.download_times}}
              </div>
              <div v-if="columnsView.includes('collection_times')">
                <span class="binfotitle">{{isGaonS?isEnglish?"Collection：":"收藏次数：":"收藏次数："}}</span>
                {{ solaBig.collection_times}}
              </div>
              <div v-if="columnsView.includes('view_times')">
                <span class="binfotitle">{{isGaonS?isEnglish?"Page View：":"浏览次数：":"浏览次数："}}</span>
                {{ solaBig.view_times}}
              </div>
            </div>
          </div>
          <div class="BigRight">
            <el-scrollbar class="bigright-scrollbar">
              <div style="padding:54px 50px 57px 50px;">
                <el-tooltip
                  class="groupname"
                  effect="light"
                  placement="top-start"
                  :content="isGaonS?(isEnglish&&((group.group_title||'').indexOf('*##*')!=-1)?(group.group_title||'').split('*##*')[1]:(group.group_title||'').split('*##*')[0]):group.group_title"
                >
                  <v-clamp autoresize :max-lines="2" expanded: true>
                    {{isGaonS?(isEnglish&&((group.group_title||'').indexOf('*##*')!=-1)?(group.group_title||'').split('*##*')[1]:(group.group_title||'').split('*##*')[0]):group.group_title}}
                  </v-clamp>
                </el-tooltip>
                <div class="picDownSize" v-if="solaBig.asset_type == 1">
                  <div class="picDownSize-type">
                    <div
                      @click="picDownSizeSelect='M'"
                      :class="['picDownSize-type-m',{'active-m':picDownSizeSelect=='M','noactive-m':picDownSizeSelect!='M'}]"
                    >
                      <el-radio v-model="picDownSizeSelect" label="M">
                        <span>{{isGaonS?isEnglish?"Small":"小图":"小图"}}</span>
                        <em>1024 x 683 px (300dpi)</em>
                      </el-radio>
                    </div>
                    <div
                      @click="picDownSizeSelect='L'"
                      :class="['picDownSize-type-l',{'active-m':picDownSizeSelect=='L','noactive-m':picDownSizeSelect!='L'}]"
                    >
                      <el-radio v-model="picDownSizeSelect" label="L">
                        <span>{{isGaonS?isEnglish?"Middle":"中图":"中图"}}</span>
                        <em>2048 x 1365 px (300dpi)</em>
                      </el-radio>
                    </div>
                    <div
                      @click="picDownSizeSelect='yt'"
                      :class="['picDownSize-type-yt',{'active-m':picDownSizeSelect=='yt','noactive-m':picDownSizeSelect!='yt'}]"
                    >
                      <el-radio v-model="picDownSizeSelect" label="yt">
                        <span>{{isGaonS?isEnglish?"Original":"原图":"原图"}}</span>
                        <em>{{solaBig.size.split('/')[0] || ''}} px (300dpi)</em>
                      </el-radio>
                    </div>
                  </div>
                  <el-dialog title="请选择尺寸" :visible.sync="sizeInfoVisible">
                    <template>
                      <el-table :data="tableData" style="width: 100%">
                        <el-table-column
                          prop="name"
                          :label="isGaonS?isEnglish?'size':'尺寸':'尺寸'"
                          width="280"
                        ></el-table-column>
                        <el-table-column
                          prop="size"
                          :label="isGaonS?isEnglish?'norm':'规格':'规格'"
                          width="280"
                        ></el-table-column>
                        <el-table-column :label="isGaonS?isEnglish?'operate':'操作':'操作'">
                          <template slot-scope="scope">
                            <el-button
                              @click="dclick(scope)"
                              type="text"
                            >{{isGaonS?isEnglish?"Download":"下载":"下载"}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-dialog>
                </div>
                <div v-if="downloadComment" class="picuselist">
                  <el-cascader
                    :placeholder="isGaonS?isEnglish?'Please select the image use':'请选择图片用途':'请选择图片用途'"
                    expand-trigger="hover"
                    v-model="selectpurposeid"
                    style="width:100%;border:#ccc"
                    :options="options"
                    :show-all-levels="false"
                    :props="optionprop"
                    @active-item-change="handleItemChange"
                  ></el-cascader>
                </div>
                <!-- <div class="BigTo">
                  <div class="toCollect" @click="addCollect">
                    <a>
                      <i v-if="changeicon" class="collect iconfont icon-shoucang"></i>
                      <i v-else class="collect iconfont icon-icon3"></i>

                      <span>添加收藏</span>
                    </a>
                  </div>
                </div>-->
                <div class="picDown">
                  <div class="downButton" @click="onlyDownload">
                    <a>
                      <img src="../../static/images/icon/downloadOn.svg" alt="">
                      <span
                        v-if="solaBig.asset_type == 1"
                      >{{isGaonS?isEnglish?"Picture Download":"图片下载":"图片下载"}}</span>
                      <span
                        v-if="solaBig.asset_type == 3"
                      >{{isGaonS?isEnglish?"Download":"视频下载":"视频下载"}}</span>
                    </a>
                  </div>
                  <div class="downButton" @click="packDownload" v-if="(solaBig.asset_type == 1) && !showPeople">
                    <a>
                      <img src="../../static/images/icon/twDownload.svg" alt="">
                      <span
                        v-if="solaBig.asset_type == 1"
                      >{{isGaonS?isEnglish?"Graphic Download":"图文下载":"图文下载"}}</span>
                    </a>
                  </div>

                  <el-dialog
                    class="picDownInfo"
                    :show-close="false"
                    :visible.sync="dialogVisible"
                    width="30%"
                  >
                    <div class="picDownInfoHead">
                      <!-- <img
                        :src="logo_src"
                        alt=""
                      >-->
                      <h2>权限提示：</h2>
                    </div>
                    <div class="picDownInfoFoot" v-if="showPeople">
                      <div style="text-align:center; margin-top:40px;">您暂无下载权限</div>
                      <div style="text-align:center">如需购买请联系在线客服</div>
                      <div style="text-align:center">客服电话：400-010-6698</div>
                      <div style="text-align:center">服务邮箱：service.rv@vcg.com</div>
                      <div style="text-align:center;margin-top:20px">
                        <el-button round @click="dialogVisible=false">确&nbsp;&nbsp;&nbsp;定</el-button>
                      </div>
                    </div>
                    <div class="picDownInfoFoot" v-else-if="webID == '111144'">
                      <div style="text-align:center; margin-top:40px;">您现在没有下载权限</div>
                      <div style="text-align:center">请联系客服（工作时间拨打010-84395196）开通权限</div>
                      <div style="text-align:center">或等待48小时，系统自动为您开通试用权限。</div>
                      <div style="text-align:center;margin-top:20px">
                        <el-button round @click="dialogVisible=false">确&nbsp;&nbsp;&nbsp;定</el-button>
                      </div>
                    </div>
                    <div class="picDownInfoFoot" v-else>
                      <div style="text-align:center; margin-top:40px;">您暂无下载权限</div>
                      <div style="text-align:center">如需购买请联系在线客服</div>
                      <div style="text-align:center">{{permission_desc}}</div>
                      <div style="text-align:center;margin-top:20px">
                        <el-button round @click="dialogVisible=false">确&nbsp;&nbsp;&nbsp;定</el-button>
                      </div>
                    </div>
                  </el-dialog>
                </div>
                <div class="info">
                  <!-- <div class="groupname">{{group.group_title}}</div> -->
                  <el-collapse v-model="activeNames">
                    <el-collapse-item name="1">
                      <template slot="title">
                        <span
                          style="font-size:14px;font-weight:600;"
                        >{{isGaonS?isEnglish?"Description":"说明":"说明"}}</span>
                      </template>
                      <div
                        class="bigpicinfo" v-if="showPeople"
                      >{{solaBig.caption.replace(/\*\*\*_\*\*\*/,'')}}</div>
                      <div
                        class="bigpicinfo" v-else
                      >{{isGaonS?(isEnglish&&((solaBig.caption||'').indexOf('*##*')!=-1)?(solaBig.caption||'').split('*##*')[1]:(solaBig.caption||'').split('*##*')[0]):solaBig.caption}}</div>
                    </el-collapse-item>
                    <el-collapse-item name="2">
                      <template slot="title">
                        <span
                          style="font-size:14px;font-weight:600;"
                        >{{isGaonS?isEnglish?"Basic info":"基本信息":"基本信息"}}</span>
                      </template>
                      <div class="bigpicinfo">
                        <span class="binfotitle">ID：</span>
                        {{solaBig.asset_id}}
                      </div>
                      <div v-if="showPeople">
                        <div class="bigpicinfo">
                          <span class="binfotitle">资源编号：</span>
                          {{vcgID}}
                        </div>

                        <!-- 人民视觉 -->
                        <div class="bigpicinfo" v-if="solaBig.asset_type == 1 && columnsView.includes('size')">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Image resolution：":"尺寸：":"尺寸："}}</span>
                          {{solaBig.size}}
                        </div>
<!--
                        <div class="bigpicinfo" v-if="columnsView.includes('credit_line')  && solaBig.source_id">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Photographer：":"作者/来源：":"作者/来源："}}</span>
                          {{newCreditLine}}
                        </div> -->



                        <div class="bigpicinfo" v-if="solaBig.asset_type == 3">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Specifications：":"规格：":"规格："}}</span>
                          {{`${solaBig.extension_info.video_code} ${solaBig.extension_info.width} x ${solaBig.extension_info.height} |  ${solaBig.extension_info.fps} FPS`}}
                        </div>

                        <div class="bigpicinfo" v-if="solaBig.asset_type == 3">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Storage size":"储存大小：":"储存大小："}}</span>
                          {{`${solaBig.size.split('/')[1]}`}} {{solaBig.mime_type ? ` - ${solaBig.mime_type}` : ''}}
                        </div>



                        <div class="bigpicinfo">
                          <span
                            class="binfotitle"
                          >{{isGaonS?isEnglish?"Copyright Reserved：":"第三方权利说明：":"第三方权利说明："}}</span>
                          <span>未取得肖像权/物权授权</span>
                        </div>
                      </div>
                      <div v-else>
                        <!-- 非人民视觉 -->
                        <div class="bigpicinfo" v-if="columnsView.includes('size')">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Image resolution：":"尺寸：":"尺寸："}}</span>
                          {{solaBig.size}}
                        </div>



                        <div class="bigpicinfo" v-if=" columnsView.includes('credit_line') && this.webID != '111140'">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Photographer：":"摄影师：":"摄影师："}}</span>
                          {{isGaonS?(isEnglish&&((solaBig.credit_line||'').indexOf('*##*')!=-1)?(solaBig.credit_line||'').split('*##*')[1]:(solaBig.credit_line||'').split('*##*')[0]):solaBig.credit_line}}
                        </div>
                        <div class="bigpicinfo" v-if="columnsView.includes('shoot_time')">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Time：":"拍摄时间：":"拍摄时间："}}</span>
                          {{solaBig.shoot_time?solaBig.shoot_time.split(' ')[0]:""}}
                        </div>
                        <div class="bigpicinfo" v-if="columnsView.includes('location')">
                          <span class="binfotitle">{{isGaonS?isEnglish?"Location：":"拍摄地点：":"拍摄地点："}}</span>
                          {{solaBig.area?
                          ((isGaonS?(isEnglish&&((solaBig.area||'').indexOf('*##*')!=-1)?(solaBig.area||'').split('*##*')[1]:(solaBig.area||'').split('*##*')[0]):solaBig.area)
                          +
                          (isGaonS?(isEnglish&&((solaBig.location||'').indexOf('*##*')!=-1)?(solaBig.location||'').split('*##*')[1]:(solaBig.location||'').split('*##*')[0]):solaBig.location)):
                          (isGaonS?(isEnglish&&((solaBig.location||'').indexOf('*##*')!=-1)?(solaBig.location||'').split('*##*')[1]:(solaBig.location||'').split('*##*')[0]):solaBig.location)}}
                        </div>
                        <div class="bigpicinfo">
                          <span
                            class="binfotitle"
                          >{{isGaonS?isEnglish?"Copyright Reserved：":"版权所有：":"版权所有："}}</span>
                          <span>{{isGaonS?(isEnglish&&((companyname||'').indexOf('*##*')!=-1)?(companyname||'').split('*##*')[1]:(companyname||'').split('*##*')[0]):companyname}}</span>
                        </div>
                      </div>


                    </el-collapse-item>

                  </el-collapse>
                </div>
              </div>
            </el-scrollbar>
            <div></div>
          </div>
        </div>
        <div class="mainBottom">
          <div class="corre">

            <h5>

              {{isGaonS?isEnglish?"In-group resources":`同一事件${typeText}`:`同一事件${typeText}`}}
              <a
                style="font-size:14px;color:#999999;margin-left:10px;"
                v-if="group.group_total>15"
                :href="'/search?isEnglish=false&type=1&text=&group_id='+group.group_id"
              >{{isGaonS?isEnglish?"View More":"查看更多":"查看更多"}}</a>
            </h5>
            <div class="picShow">
              <a
                v-for="(item,index) in group.items"
                :key="index"
                v-if="index<15"
                @click="intoDetail(item,index)"
                :item="item"
              >
                <img v-if="solaBig.asset_type == 1" oncontextmenu="return false" :src="item.extension_info.oss_400" alt />
                <video
                    v-if="solaBig.asset_type == 3"
                    :src="item.extension_info.preview_ossid"
                    :poster="item.extension_info.video_image"
                    @mouseover="videoPlayback($event)"
                    @mouseout="videoStopped($event)"
                    muted
                    ref="autoo"
                  ></video>
                <div class="ImgList-textB">
                  <p>{{item.shoot_time?item.shoot_time.split(' ')[0]:
                    item.created_at?item.created_at.split(' ')[0]:''}}</p>
                  <el-tooltip
                    v-if="showPeople"
                    class="groupname"
                    effect="light"
                    placement="top-start"
                    :content="item.caption.replace(/\*\*\*_\*\*\*/,'')"
                  >
                    <v-clamp autoresize :max-lines="2" expanded: true>
                      {{item.caption.replace(/\*\*\*_\*\*\*/,'')}}
                    </v-clamp>
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    class="groupname"
                    effect="light"
                    placement="top-start"
                    :content="isGaonS?(isEnglish&&((item.caption||'').indexOf('*##*')!=-1)?(item.caption||'').split('*##*')[1]:(item.caption||'').split('*##*')[0]):item.caption"
                  >
                    <v-clamp autoresize :max-lines="2" expanded: true>
                      {{isGaonS?(isEnglish&&((item.caption||'').indexOf('*##*')!=-1)?(item.caption||'').split('*##*')[1]:(item.caption||'').split('*##*')[0]):item.caption}}
                    </v-clamp>
                  </el-tooltip>
                </div>
                <div class="ImgList-zzc" :style="{'height': (solaBig.asset_type == 3 ? '50px' : '100%')}">
                  <s :style="{'background': (solaBig.asset_type == 3?'none':'#000')}"></s>
                  <p>
                    <a @click.stop="collectImg(item.id)">
                      <img src="../../static/images/icon/collect.svg" alt="">
                    </a>
                    <a @click.stop="downImg(item)">
                      <img src="../../static/images/icon/downloadUp.svg" alt="">
                    </a>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <!-- 下载弹窗 -->
    <el-dialog :visible.sync="ifBoxshow" class="downLoadBox" :before-close="handleClose" >
      <div style="margin:0 auto;">
        {{isGaonS?isEnglish?"Select image size:":"选择图片尺寸：":"选择图片尺寸："}}
        <el-radio-group v-model="downLoadSize" size="medium">
          <el-radio-button label="M">{{isGaonS?isEnglish?'Small':'小图':'小图'}}</el-radio-button>
          <el-radio-button label="L">{{isGaonS?isEnglish?'Middle':'中图':'中图'}}</el-radio-button>
          <el-radio-button :label="isGaonS?isEnglish?'Original':'原图':'原图'">
            {{isGaonS?isEnglish?'Original':'原图':'原图'}}
          </el-radio-button>
        </el-radio-group>
      </div>
      <p  style="height:40px;line-height:40px;text-align:center;">
        {{downLoadSize=="M"?"1024 x 683 px (300dpi)":downLoadSize=="L"?"2048 x 1365 px (300dpi)":"5616 x 3744 px (300dpi)"}}
      </p>
      <div style="margin:0 auto;text-align:center;">
        <el-button size="small" @click="ifBoxshow = false">{{isGaonS?isEnglish?"Cancel":"取 消":"取 消"}}</el-button>
        <el-button size="small" type="primary" @click="getDownLoadFn(get_download,downLoadSize)">{{isGaonS?isEnglish?"Confirm download":"确认下载":"确认下载"}}</el-button>
      </div>
    </el-dialog>
    <!-- <el-footer v-if="hidefooter" height="316px" style="padding:0px"> -->

    <el-footer v-if="hidefooter" :style="{'height':  footerHeight}">
      <help-footer v-if="this.webID == '111142'"></help-footer>
      <people-footer v-else-if="showPeople"></people-footer>
      <homeFooter v-else :logo="logo"></homeFooter>
    </el-footer>
    <collect v-if="isShowCollect" v-model="isShowCollect" :choceImg="curItemId + ''" :assetType="solaBig.asset_type"></collect>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="40%"
      center>
      <span>因文件大小超过100M，请前往“个人中心-我的下载-大文件链接”点击链接下载该图片原文件</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import helpFooter from "../components/helpFooter.vue"; //底部
import searchAndselect from "../components/searchAndselect.vue";
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //顶部
import homeFooter from "../components/homeFooter.vue"; //顶部
import peopleFooter from "../components/peopleFooter.vue"; //顶部
import collect from "../components/collect.vue";
import { mapActions, mapGetters } from "vuex";
import searchHorizontal from "../components/searchHorizontal";
import VClamp from 'vue-clamp';

import {
  getResource,
  getGroup,
  getModuleInfo,
  onlyDownload,
  getImageBlob,
  getdoctitle,
  getwebid,
  downloadAttachment,
  getPurposeNodes,
  getWebUser,
  getassetsInfoCms,
  getVCGID
} from "@/services/api.js";
import {packLoad} from "@/services1/index.js";
export default {
  name: "toBigPic",
  components: {
    homeHeader,
    homeFooter,
    peopleFooter,
    collect,
    homeFooterAd,
    VClamp,
    searchAndselect,
    searchHorizontal,
    helpFooter
  },
  data() {
    return {
      centerDialogVisible:false,
      webID: 1,
      downLoadSize:"M",
      ifBoxshow:false,
      curItemId: "",
      selectpurposeid: [],
      options: [],
      optionprop: {
        label: "cname",
        value: "id",
        children: "children"
      },
      picuselist_options: [
        {
          value: 1,
          label: "新媒体编辑使用-微博、微信"
        },
        {
          value: 2,
          label: "网络用途-广告"
        },
        {
          value: 3,
          label: "线下推广"
        }
      ],
      downloadComment: false, //是否开通输入下载用途描述
      textarea2: "", //图片用途
      radio: "2",
      sizeInfoVisible: false,
      picDownSizeSelect: "yt",
      dialogVisible: false,
      changeicon: true,
      opacity: "0.68",
      imgdesc: "",
      companyname: "",
      activeNames: ["1", "2", "3", "4"],

      intoList: {},
      //单张大图
      solaBig: [{ extension_info: { oss_800: "" } }, { keywords: "" }],
      //相关图片
      groupPic: [{ data: {} }, { to: null }, { total: null }],
      group: {
        items: []
      },
      copyText: {},
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      isShowCollect: false,
      webID: "",
      preandindex: -1,
      selectSize: "",
      tableData: [
        {
          name: "M",
          size: "800x533 px"
        },
        {
          name: "L",
          size: "1024x683 px"
        },
        {
          name: "原图",
          size: "6000x4000 px"
        }
      ],
      oriSize: "",
      permission_desc: "或拨打业务联系电话",
      integral_switch: 0 ,//是否开通积分功能，0不开通  1开通
      pcSize: '',//图片大小
      typeText: '资源',
      newCreditLine:'',
      footerHeight: '316px',
      vcgID:'',
    };
  },
  beforeCreate() {},
  created() {

    getassetsInfoCms({
      assetId: this.$route.query.asset,
      visitorVolume: 1
    }).then(res => {
      console.log(res);
    });

    //判断传过来的语言类型
    let iseng = this.$route.query.isEnglish;
    if (iseng) {
      if (iseng == "true") {
        iseng = 1;
      }
      if (iseng == "false") {
        iseng = 0;
      }
      this.setisEnglish(iseng);
    }
    this.preandindex = parseInt(this.$route.query.index);
    this.intoList = {
      asset: this.$route.query.asset,
      key: this.$route.query.key
    };
    this.webID = this.$route.query.webid;

    getwebid({ domainName: window.location.host }).then(data => {
      if (data) {
        this.webID = data.data;

        switch (this.webID) {
          case "111142":
            this.footerHeight = "120px";
            break;
          case "111152":
            this.footerHeight = "auto";
            break;
          case "111111":
            this.footerHeight = "auto";
            break;
          default:
            this.footerHeight = "316px";
        }

        this.getResourceSola(this.intoList.asset);
        this.getResourceGroup(this.intoList.key);
        this.getGroup(this.intoList.key);

        this.getModuleInfo();
        this.getModuleLog();
        this.getdoctitle();
      }
    });
    console.log(this.solaBig,'this.solaBig')

    var loginToken = sessionStorage.getItem("token");
    let optionParam = {
      headers: { Authorization: "Bearer " + loginToken }
    };

    getPurposeNodes(null, optionParam).then(x => {
      x.data.forEach(item => {
        item["children"] = [];
      });
      this.options = x.data;
    });
  },
  mounted() {
    switch (this.webID) {
      case "111142":
        this.footerHeight = "120px";
        break;
      case "111152":
        this.footerHeight = "auto";
        break;
      case "111111":
        this.footerHeight = "auto";
        break;
      default:
        this.footerHeight = "316px";
    }

    this.getPermissionDesc();
    var a = JSON.parse(sessionStorage.getItem("switches"));
    let userInfo = sessionStorage.getItem("user");

    // 判断是否有图片用途权限
    getWebUser({ uid: this.webId }).then(res => {
      let purpose = res.data.purpose;

      this.downloadComment = purpose ? true : false;
      //a.downloadComment.status == 1 && userInfo ? true : false;
    });
  },
  computed: {
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",
      "logo_src",
      "hidefooter",
      "column_switch",
      "isGaonS",
      "isEnglish",
      "showPeople",
    ]),
    columnsView() {
      if (this.column_switch) {
        return this.column_switch
          .filter(x => x.edit_switch == 1 && x.view_switch == 1)
          .map(res => res.real_column_name);
      } else {
        return [];
      }
    },
    solaBigextension_infooss_800() {
      if (this.solaBig.extension_info) {
        return this.solaBig.extension_info.oss_800_watermark;
      } else {
        return "";
      }
    },
    solaBigkeywords() {
      if (this.solaBig.keywords == "" || !this.solaBig.keywords) {
        return [];
      } else {
        if (this.solaBig.keywords.split(",").length > 0) {
          return this.solaBig.keywords.split(",");
        } else {
          return [];
        }
      }
    }
  },
  watch: {
    //监听是否切换大图  得判断当前大图是否已经保存了
    columnsView(val) {
      console.log(val);
    },
    solaBig(val){
      if(this.showPeople){
        const {id} = val;
        getVCGID({
          "asset_ids":`${id}`
        }).then(
          res => {
            const {status_code, data} = res;
            if(status_code){
              if(data.length){
                this.vcgID = data[0][id];
              }
            }else{

            }
          }
        );
      }
    }
  },
  methods: {
    handleClose(done) {
       done();
    },
    //划上播放视屏
    videoPlayback(event) {
      event.path[0].setAttribute("autoplay", "autoplay");
      event.path[0].play();
    },
    //离开视屏停止播放
    videoStopped(event) {
      event.path[0].pause();
    },
    ...mapActions(["setisEnglish","aloneDownload"]),
    async handleItemChange(val) {
      var index = this.options.findIndex(x => x.id == val[0]);
      var loginToken = sessionStorage.getItem("token");
      let optionParam = {
        headers: { Authorization: "Bearer " + loginToken }
      };

      let data = await getPurposeNodes({ pid: val[0] }, optionParam);
      if (data.data.length != 0) {
        this.options[index].children = data.data;
      } else {
        this.options[index].children = null;
      }
    },
    getPermissionDesc() {
      if (window.location.host.indexOf("nf.vcg") > -1) {
        this.permission_desc = "或拨打业务联系电话020-37635516";
      } else if (window.location.host.indexOf("photos.cyol") > -1) {
        this.permission_desc = "或拨打业务联系电话010-64098766";
      } else if (window.location.host.indexOf("didaofengwu") > -1) {
        this.permission_desc = "或拨打业务联系电话010-84909521";
      }
    },
    dclick(e) {
      switch (e.$index) {
        case 0:
          this.onlyDownload("800");
          break;
        case 1:
          this.onlyDownload("1024");
          break;
        default:
          this.onlyDownload();
          break;
      }
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    getdoctitle() {
      getdoctitle({ uid: this.webID }).then(x => {
        this.integral_switch = x.data.integral_switch;
      });
    },

    // 单一下载  无积分下载
    onlyDownloadNoscore(size) {
      let userInfo = sessionStorage.getItem("user");
      if (!userInfo) {
        this.$message.error("请登录后重试");

        setTimeout(() => {
          const oauth_token_url = JSON.parse(
            sessionStorage.getItem("oauthTokenUrl")
          );
          window.location.href = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=${oauth_token_url.client_id}&theme=full/simple/embed"`;
        }, 800);
      } else {
        this.selectSize = size;
        var a = JSON.parse(sessionStorage.getItem("switches"));
        // this.downloadComment = a.downloadComment.status == 1 ? true : false;
        let data = null;
        if (!this.downloadComment) {
          data = {
            assetId: this.solaBig.asset_id,
            comment: this.textarea2
          };
        } else {
          if (this.selectpurposeid.length == 0) {
            this.$message({
              type: "warning",
              message: "请选择使用用途"
            });
            return;
          }
          data = {
            assetId: this.solaBig.asset_id,
            purpose_id: this.selectpurposeid[this.selectpurposeid.length - 1]
          };
        }
        if (Number(size)) {
          data["size"] = Number(size);
        } else {
          switch (this.picDownSizeSelect) {
            case "M":
              data["size"] = "800";
              break;
            case "L":
              data["size"] = "1024";
              break;
          }
        }

        downloadAttachment(data).then(res => {
          if (res.status_code == 1) {
            if(res.data.data.url == 0){//url值为0时为大文件,执行异步下载并生成链接，
                this.centerDialogVisible = true;
                return;
            }else{
              let a = document.createElement("a");
              a.href = res.data.data.url;
              let mimeTypeStr = res.data.data.orgPath;

              var key = mimeTypeStr.lastIndexOf(".");
              var mimeType = mimeTypeStr.substr(key + 1);
              a.download = this.solaBig.asset_id + "." + mimeType;
              a.click();
            }
          } else {
            this.dialogVisible = true;
          }
        });
      }
    },
    onlyDownload(size) {
      if (this.integral_switch != 1) {
        this.onlyDownloadNoscore(size);
      } else {
        let userInfo = sessionStorage.getItem("user");
        if (!userInfo) {
          //rediect =1  登录后调回当前页面
          // this.$router.push({
          //   path: "/login?redirect=1"
          // });

          window.location.href = "https://login.ihep.ac.cn"
        } else {
          this.selectSize = size;
          var a = JSON.parse(sessionStorage.getItem("switches"));
          // this.downloadComment = a.downloadComment.status == 1 ? true : false;
          let data = null;
          if (!this.downloadComment) {
            data = {
              assetId: `${this.solaBig.asset_id}`,
              comment: this.textarea2
            };
          } else {
            if (this.selectpurposeid.length == 0) {
              this.$message({
                type: "warning",
                message: "请选择使用用途"
              });
              return;
            }
            data = {
              assetId: this.solaBig.asset_id,
              purpose_id: this.selectpurposeid[this.selectpurposeid.length - 1]
            };
          }
          if (Number(size)) {
            data["size"] = Number(size);
          } else {
            switch (this.picDownSizeSelect) {
              case "M":
                data["size"] = "800";
                break;
              case "L":
                data["size"] = "1024";
                break;
            }
          }
          console.info('data',data);
          downloadAttachment(data).then(res => {
            if (res.status_code == 1) {
              if(res.data.data.url == 0){//url值为0时为大文件,执行异步下载并生成链接，
                 this.centerDialogVisible = true;
                 return;
              }else{
                console.log(9999999)
                let a = document.createElement("a");
                a.href = res.data.data.url;
                let mimeTypeStr = res.data.data.orgPath;
                var key = mimeTypeStr.lastIndexOf(".");
                var mimeType = mimeTypeStr.substr(key + 1);
                a.download = this.solaBig.asset_id + "." + mimeType;
                a.click();
              }
            } else {
              this.dialogVisible = true;
            }
          });
          this.ifBoxshow = false;
        }
      }
    },
    // 下载
    downImg(item) {
      let userInfo = sessionStorage.getItem("user");
      if (!userInfo) {
        this.$message.error("请登录后重试");

        setTimeout(() => {
          const oauth_token_url = JSON.parse(
            sessionStorage.getItem("oauthTokenUrl")
          );
          window.location.href = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=${oauth_token_url.client_id}&theme=full/simple/embed"`;
        }, 800);

      } else {
        this.get_download = item.id;
        this.ifBoxshow = true;
      }
    },
    //下载函数
    getDownLoadFn(get_download,size){
      let picsize = "";
      if(size=="M"){
        picsize = 800;
      }else if(size=="L"){
        picsize = 1024;
      }else{
        picsize = "";
      }
      this.aloneDownload({assetId:get_download,size:picsize});
      this.ifBoxshow = false;
    },
    // 打包下载
    packDownload() {
      let size = "";
      let userInfo = sessionStorage.getItem("user");
      if (this.downloadComment && this.selectpurposeid.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择使用用途"
        });
        return;
      }
      if (!userInfo) {
        this.$message.error("请登录后重试");

        setTimeout(() => {
          const oauth_token_url = JSON.parse(
            sessionStorage.getItem("oauthTokenUrl")
          );
          window.location.href = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=${oauth_token_url.client_id}&theme=full/simple/embed"`;
        }, 800);

      } else {
        var a = this.solaBig.asset_id;
        switch (this.picDownSizeSelect) {
          case "M":
            size = "800";
            break;
          case "L":
            size = "1024";
            break;
        }
        packLoad({assetIds:a,size:size}).then(res => {
            if (res.status_code === 1) {
              this.downloadFiles(res.data)
            } else {
              this.$message.error(res.message.size[0])
            }
          });
      }
    },
    // 压缩包下载
    downloadFiles (href) {
      const fileName = new Date().getTime()
      const link = document.createElement('a')
      link.display = 'none'
      link.download = fileName
      link.href = href
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        document.body.removeChild(link)
      }, 200)
    },
    // 添加到收藏夹
    // 收藏
    collectImg(item) {
      let userInfo = sessionStorage.getItem("user");
      if (!userInfo) {
        this.$message.error("请登录后重试");

        setTimeout(() => {
          const oauth_token_url = JSON.parse(
            sessionStorage.getItem("oauthTokenUrl")
          );
          window.location.href = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=${oauth_token_url.client_id}&theme=full/simple/embed"`;
        }, 800);
      } else {
        this.isShowCollect = true;
        this.curItemId = item;
      }
    },
    //单张大图获取
    getResourceSola(asset, index) {
      var data = {
        asset_id: asset,
        customer_id: this.webID,
      };

      getResource(data, null).then(res => {
        if (res.status_code == 1) {
          this.solaBig = res.data.data[0];

          const {is_copyright,asset_type,source_id,credit_line} = this.solaBig;
          if(asset_type == 1)
            this.typeText = "图片";
          if(asset_type == 3)
            this.typeText = "视频";

          switch(source_id){
            case 1:
              this.newCreditLine = "签约供稿人/人民视觉";
              break;
            case 3:
              this.newCreditLine = "签约供稿人/人民视觉";
              break;
            case 8:
              this.newCreditLine = credit_line;
              break;
            case 9:
              this.newCreditLine = "签约供稿人/人民视觉";
              break;
            case 10:
              this.newCreditLine = "签约供稿人/人民视觉";
              break;
            case 11:
              this.newCreditLine = credit_line;
              break;
            default:
               this.newCreditLine = "";
          }

          switch(is_copyright){
            case 1:
              this.companyname = '独家代理';
              break;
            case 2:
              this.companyname = '非独家代理';
              break;
            case 3:
              this.companyname = this.customName;
              break;
            case 4:
              this.companyname = '视觉中国';
              break;
          }
          this.pcSize = res.data.data[0].size;
          let query = {};
          query.asset = this.solaBig.asset_id;
          query.key = this.$route.query.key;
          query.index = index ? index : this.$route.query.index;
          this.$router.push({ query: query });
        }
      });
    },
    //获取相关图片
    getResourceGroup(key) {
      var data = {
        group_id: key,
        customer_id: this.webID,
        sort_by_number: "desc",
        sort_by_created: "asc",
      };

      getResource(data).then(res => {

        if (res.status_code == 1) {
          this.groupPic = res.data;
        }
      });
    },
    //前后按钮
    preAndNext(type) {
      this.preandindex = parseInt(this.$route.query.index);
      if(type == 'gt'){
        this.preandindex = this.preandindex+1
      }else{
        this.preandindex = this.preandindex-1
      }
      // let index = type
      //   ? this.$route.query.index - 0 - 1
      //   : this.$route.query.index - 0 + 1;
      // index < 0 && (index = this.group.items.length - 1);
      // index >= this.group.items.length && (index = 0);
      let index = this.preandindex;
      if (index < 0) index = 0;
      if (index > this.group.items.length - 1) {
        index = this.group.items.length - 1;
      }
      this.getResourceSola(this.group.items[index].id, index);
      this.preandindex = index;
    },
    // 跳往大图
    intoDetail(item, index) {
      this.getResourceSola(item.id, index);
    },
    //获取组资源
    getGroup(key) {
      var data = {
        groupId: key,
        customer_id: this.webID
      };
      getGroup(data).then(res => {

        if (res.status_code == 1) {
          // 排除当前资源
          let newData = JSON.parse(JSON.stringify(res.data))
          newData = res.data.items.filter((item,index) => {
            if(item.id != this.$route.query.asset){
              return item;
            }
          });
          res.data.items = newData;
          this.group = res.data;
        }
      });
    },
    //授权处理
    getCopyright() {
      if (this.solaBig.is_copyright === 1) {
        return "RM";
      } else if (this.solaBig.is_copyright === 2) {
        return "RM";
      } else if (this.solaBig.is_copyright === 3) {
        return "RR";
      } else if (this.solaBig.is_copyright === 4) {
        return "ZY";
      }
    },
    //获取模块版权声明
    getModuleInfo() {
      let data = {
        module_id: 9,
        web_id: this.webID,
        use_sort_num: 1,
        sort: "desc",
        channel_id: this.curModelInfo.id
      };
      let query = {
        page: 1,
        page_nums: 1
      };
      getModuleInfo(data, query).then(res => {
        if (res.status_code == 1) {
          this.copyText = res.data.list[0];
        }
      });
    },
    getModuleLog() {
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            channel_id: this.curModelInfo.id
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
        }
      }, 0);
    },
    //关键词搜索
    toSearch(item) {
      this.$router.push({
        path: "/search",
        query: {
          text: encodeURI(item)
        }
      });
    }
  }
};
</script>

<style lang="less">
.bigpicinfo {
  color: #333;
  font-size: 12px;
  line-height: 20px;
  .binfotitle {
    font-weight: 500;
  }
}
.tobigpicmain {
  font-family: "微软雅黑", "Microsoft YaHei", "Helvetica Neue For Number",
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}
.main {
  padding: 0;
  background-color: #F5F6FA;
  .container {
    @media screen and (max-width:1680px) {
      width: 1200px;
      .BigLeft{
        width: 800px;
        .BigSwiper{
          width: 584px;
          img{
            max-width: 584px;
          }
        }
        .BigTab{
          padding: 0 30px;
        }
      }
      .mainBottom .corre .picShow{
        width: 1216px;
      }
    }
    width:1680px;
    margin-top: 20px;
  }
  // .el-scrollbar {
  //   overflow:scroll;
  // }
}

.BigLeft {
  margin-top: 22px;
  float: left;
  width: 1280px;
  height: 760px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  .Biglayer-img{
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(1.2);
    -webkit-filter: blur(18px); /* Chrome, Opera */
       -moz-filter: blur(18px);
        -ms-filter: blur(18px);
            filter: blur(18px);
  }
  .Biglayer{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    opacity: 0.7;
  }
  .BigButton{
    position: absolute;
    top: 30px;
    right: 30px;
    a{
      float: left;
      width:90px;
      height:36px;
      line-height: 36px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-left: 10px;
      font-size: 12px;
      color:#333;
      text-align: center;
      img{
        position: relative;
        top: 3px;
      }
    }
  }
  .BigSwiper {
    position: relative;
    width: 789px;
    height: 600px;
    line-height: 600px;
    .bigChange {
      text-align: center;
      height: 100%;
    }

    img {
      // width: 100%;
      // height: 600px;
      max-width: 789px;
      max-height: 600px;
      vertical-align: middle;
    }
  }
  .BigTab {
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    padding: 0 70px;
    box-sizing: border-box;
    .prev {
      cursor: pointer;
      position: relative;
      float: left;
      width: 40px;
      height: 40px;
      color: #999999;
      font-size: 28px;
      text-align: center;
      line-height: 104px;
      .lt {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -9px;
        margin-left: -3px;
        width: 18px;
        height: 18px;
        transform: rotate(45deg);
        border: 2px solid;
        border-color: transparent transparent #999999 #999999;
      }
    }
    .next {
      cursor: pointer;
      position: relative;
      float: right;
      width: 40px;
      height: 40px;
      color: #999999;
      font-size: 28px;
      text-align: center;
      .gt {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -9px;
        margin-left: -15px;
        width: 18px;
        height: 18px;
        transform: rotate(45deg);
        border: 2px solid;
        border-color: #999999 #999999 transparent transparent;
      }
    }
  }
  .Big-info-ll{
    position: absolute;
    bottom: 40px;
    height: 20px;
    line-height: 20px;
    >div{
      display: inline-block;
      color: #333333;
      font-size: 14px;
      padding: 0 20px;
    }
  }
  .el-carousel__container {
    margin: 24px;
    width: 94%;
    height: 600px;
    .el-carousel__item {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.BigRight {
  // background-color: #f1f1f1;
  padding: 0px;
  border-radius: 3px;
  margin-top: 22px;
  float: right;
  width: 400px;
  height: 760px;
  box-sizing: border-box;
  background-color: #fff;
  .BigTo .toCollect a img,
  svg:not(:root) {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    font-size: 20px;
    color: #585555;
    line-height: 20px;
    margin-right: 3px;
  }
  .toCollect {
    position: relative;
    .ball {
      position: absolute;
      z-index: 99999999999999;
      height: 20px;
      width: 20px;
      background: red;
      border-radius: 10px;
      left: 130px;
      transition: all 1s cubic-bezier(0.49, -0.29, 0.75, 0.41); /*贝塞尔曲线*/
    }
  }
  .price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    > div:nth-child(1) {
      span {
        color: red;
        font-size: 20px;
      }
    }
    > div:nth-child(2) {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .bigright-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
      margin-right: 0px;
    }
    .el-scrollbar__bar.is-horizontal {
      height: 0px;
      left: 2px;
    }
  }
  .BigTo {
    > div:hover {
      background-color: #2789ee;
      a {
        i,
        span {
          color: #fff;
        }
      }
    }
    > div.inShoppingCar:hover {
      background-color: inherit;
    }
    > div.inShoppingCar {
      a {
        i,
        span {
          color: #ccc;
        }
      }
    }
    div {
      border-radius: 3px;
      // width: 92%;
      height: 40px;
      background-color: #ffffff;
      text-align: center;
      border: 1px solid #ccc;
      line-height: 40px;
      margin: 15px 10px 12px 10px;
      cursor: pointer;
      a {
        .conform {
          background: url("../../static/images/icon/checkone.png") no-repeat;
        }
        .collect {
          // background: url("../../static/images/icon/collectone.png") no-repeat;
        }
        i {
          display: inline-block;
          // width: 18px;
          // height: 18px;
          vertical-align: middle;
          margin-right: 8px;
          font-size: 20px;
          color: #585555;
        }

        span {
          font-size: 14px;
          color: #585555;
          vertical-align: middle;
        }
      }
    }
  }
  .selectSize {
    .selectText {
      width: 320px;
      color: #333;
      font-size: 14px;
      margin: 12px auto 0 auto;
      padding-bottom: 10px;
      border-bottom: 2px solid #979797;
    }
    .textSize {
      width: 100%;
      margin: 12px auto 0 12px;
      height: 40px;
      li {
        float: left;
        margin-right: 6px;
        width: 39px;
        height: 39px;
        text-align: center;
        line-height: 39px;
        border: 1px solid #ededed;
      }
    }
    .selectTextBottom {
      width: 320px;
      color: #333;
      font-size: 12px;
      margin: 12px auto 0 auto;
      padding-bottom: 10px;
      border-bottom: 2px solid #979797;
    }
  }
  .picuselist {
    .el-input__inner {
      border: 1px solid #ccc;
    }
  }
  .picDownSize {
    margin-top: 19px;
    .picDownSize-type {
      .noactive-m {
        background-color: #fff;
      }
      .active-m {
        background-color: #F9F9FC;
      }
      >div{
        position: relative;
        width: 100%;
        height: 48px;
        line-height: 48px;
        cursor:pointer;
        .el-radio{
          position: absolute;
          box-sizing: border-box;
          padding-left: 20px;
          width: 100%;
          height: 100%;
          line-height: 48px;
          span{
            margin: 0;
            padding: 0;
          }
          .el-radio__label span{
            margin-left: 16px;
            font-size: 14px;
            color:#333333;
          }
        }
        em{
          float: right;
          margin-right: 20px;
          color:#333333;
          font-size: 14px;
        }
      }
    }
  }
  .picuselist{
    margin-top: 15px;
  }
  .picDown {
    .picDownInfo {
      .el-dialog {
        .el-dialog__header {
          padding: 0px;
        }
        .el-dialog__body {
          padding: 0px;
          .picDownInfoHead {
            border-bottom: 1px solid rgba(0, 0, 0, 0.52);
            padding: 5px 15px;
            height: 70px;
            line-height: 70px;
            h2 {
              font-size: 20px;
            }
            img {
              height: 100%;
            }
          }
          .picDownInfoFoot {
            height: 150px;
          }
        }
      }
    }
    .downButton {
      margin-top: 15px;
      height: 50px;
      background-color: #2789ee;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      a {
        img{position: relative;top: 6px;right: 3px;}
        span {
          font-size: 16px;
          color: #fff;
          vertical-align: middle;
        }
      }
    }
    .downText {
      width: 320px;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin: 12px auto 0 auto;
      padding-bottom: 10px;
      border-bottom: 2px solid #979797;
    }
  }
  .groupname {
    font-size: 20px;
    overflow: hidden;
    color: #333;
    max-height: 56px;
    line-height: 28px;
  }
  .info {
    width: 300px;
    margin-top: 20px;
    box-sizing: border-box;
    .infoTitle {
      font-size: 14px;
      margin-top: 8px;
      padding-bottom: 8px;
      border-bottom: 2px solid #979797;
      span {
        font-size: 12px;
        color: #007bfe;
        float: right;
        margin-right: 3px;
        width: 10px;
        font-weight: bold;
      }
    }
    .infoKey {
      margin-top: 8px;
      padding-bottom: 8px;
      padding-top: 8px;
      border-bottom: 2px solid #979797;
      border-top: 2px solid #979797;
      margin-bottom: 10px;
      font-size: 14px;
      span {
        font-size: 12px;
        color: #007bfe;
        float: right;
        margin-right: 3px;
        width: 10px;
        font-weight: bold;
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
    .keyWord {
      overflow: hidden;
      overflow-y: scroll;
      width: 100%;
      height: 111px;
      li {
        float: left;
        margin-right: 10px;
        border: 1px solid #757575;
        color: #757575;
        font-size: 12px;
        border-radius: 3px;
        padding: 3px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      li:hover {
        border: 1px solid black;
        color: black;
      }
    }
  }
}

.mainBottom {
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;
  h5 {
    font-weight: 500;
    font-size: 24px;
    color: #333;
    height: 24px;
    line-height: 24px;
    margin: 50px 0px 24px 0;
  }
  .corre {
    .groupcaptiondetail {
      margin-top: 10px;
      // border: 1px solid #e0e0e0;
      border-radius: 3px;
      // color: rgba(0, 0, 0, 0.52);
      .captiontitle {
        // font-weight: bold;
        color: #303133;
        font-size: 13px;
      }
    }
    margin: 0 auto;
    width: 100%;
    p {
      margin: 30px 0 16px 6px;
      a {
        margin-left: 12px;
      }
    }
    .picShow {
      width: 1696px;
      position: relative;
      top: -8px;
      left: -8px;
      display: flex;
      flex-wrap: wrap;
      &::after {
        content: "";
        flex-grow: 999999;
      }
      a:hover .ImgList-zzc{
        display: block;
      }
      a {
        position: relative;
        margin: 8px;
        flex-grow: 1;
        line-height: 0;
        float: left;
        cursor: pointer;
        img {
          height: 246px;
          min-width: 100%;
          max-width: 100%;
          object-fit: cover;
        }
        video {
            min-width: 100%;
            max-width: 100%;
            height: 246px;
            object-fit: cover;
            cursor: pointer;
          }
        .ImgList-textB{
          z-index: 2;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          max-height:80px ;
          box-sizing: border-box;
          padding: 0 16px 20px 16px;
          p{
            padding: 0;
            margin: 0 0 8px 0;
            height: 12px;
            line-height: 12px;
            color:#fff;
            font-size: 12px;
          }
          span{
            color:#fff;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .ImgList-zzc{
          display: none;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          s{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: #000;
            opacity: 0.5;
          }
          p{
            margin: 0;
            padding: 0;
            position: absolute;
            height: 24px;
            width: 60px;
            right: 16px;
            top: 16px;
            a{
              width: 24px;
              height: 24px;
              float: left;
              margin:0 0 0 6px;
              background:rgba(255,255,255,0.6);
              border-radius:4px;
              padding: 5px;
              img{
                min-width: 0;
                width: 14px;
                height: 14px;
              }
            }
          }
        }
      }
    }
  }
  .copyRight {
    margin-top: 30px;
    // border-top: 2px solid #e5e5e5;
    width: 100%;
    padding-top: 20px;
    p {
      font-size: 12px;
      color: #6f6f6f;
      margin-bottom: 10px;
    }
    .copyRightT {
      color: #303133;
      font-size: 13px;
      margin-right: 10px;
    }
    .copyRightBody {
      color: rgba(0, 0, 0, 0.52);
    }
  }
}

.fixed {
  position: fixed;
  right: 30px;
  bottom: 30px;
  .show {
    background: white;
    opacity: 1;
    z-index: 99999;
    border: 1px solid #ebebeb;
    box-shadow: 1px 1px #ebebeb;
    border-radius: 5px;
    cursor: pointer;
    padding: 10px 20px;
    width: 150px;
    position: absolute;
    left: -160px;
    top: -20px;

    > div {
      font-size: 12px;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
    }
  }
}

.el-message-box .el-message-box__header {
  background: white;
  border-bottom: none;
}
.el-message-box__btns button:nth-child(1) {
  color: white;
  border-color: none;
  background: #de0027;
}
.el-button--primary {
  border: none;
}
.el-button--primary:hover {
  background: #de0027 !important;
  color: white;
}
.el-button--primary:hover {
  color: white;
}
.shoppingCarWrapper {
  // height: 50px;
  // width: 50px;
  padding: 5px;
  width: 35px;
  height: 35px;
  border: 1px solid #e0e0e0;
  border-radius: 175px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  img {
    display: block;
  }
}
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
  text-align: center;
}
.el-message-box__btns {
  text-align: center;
}
.el-tooltip__popper{
  max-width: 300px;
}
.el-tooltip__popper.is-light{
  border: 1px solid #ebeef5;
  .popper__arrow{
    border-top-color: #fff!important;
  }
  .popper__arrow::after{
    border-top-color: #ebeef5!important;
  }
}
.downLoadBox .el-dialog {
    width: 430px;
}
</style>



// WEBPACK FOOTER //
// src/page/toBigPic.vue